/**
 * Garde de route.
 *
 * Purement cosmétique : la vraie barrière est le JWT vérifié par l'API à chaque
 * requête. Ceci évite juste d'afficher un dashboard vide à quelqu'un qui n'est
 * pas connecté.
 */

import { roleAllowsPage } from '@shared/types/auth';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, role } = useAuth();
  const { pathname, search } = useLocation();

  // `replace` : la page protegee ne doit pas rester dans l'historique, sinon
  // le bouton « precedent » y ramene apres la redirection.
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Rôle pas encore relu (session d'avant les rôles) : un instant de blanc.
  if (role === null) return null;
  // Page hors du rôle : retour au Résumé, période gardée.
  if (!roleAllowsPage(role, pathname)) return <Navigate to={{ pathname: '/', search }} replace />;

  return <>{children}</>;
}
